export default {
  kreaResource: 'Recurso Krea'
}

export const en = {
  kreaResource: 'Krea Resource'
}

export const ca = {
  kreaResource: 'Recurso Krea'
}
